import { AxiosUtil } from '../utils/axios-util'
import { errorResponseNotification } from './notification-service'
import EventConstants from '../constants/EventConstants'

const getPageUrl = ({ page, perPage, eventId, planId }) => {
  let pageUrl = page + '&per_page=' + perPage
  pageUrl = eventId ? pageUrl + '&event_id=' + eventId : pageUrl
  pageUrl = planId ? pageUrl + '&plan_id=' + planId : pageUrl
  return pageUrl
}

export const getItemsWithoutPlanId = ({
  eventId,
  bidId = undefined,
  page,
  perPage,
  requestBody,
}) => {
  let url =
    EventConstants.POTENTIAL_ITEMS +
    'aggregations_search_with_bps?page=' +
    getPageUrl({ page, perPage, eventId }) +
    '&plan_unclaimed=true'

  if (bidId) {
    url = url + '&bp_ids=' + bidId
  }

  return AxiosUtil.post(url, requestBody).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const claimProductsIntoPlan = productsAndPlanIds => {
  return AxiosUtil.put(
    EventConstants.POTENTIAL_ITEMS,
    productsAndPlanIds,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getItemsWithoutEventId = ({
  planId,
  page,
  perPage,
  requestBody,
}) => {
  return AxiosUtil.post(
    EventConstants.POTENTIAL_ITEMS +
      'aggregations_search_with_bps?page=' +
      getPageUrl({ page, perPage, planId }) +
      '&event_unclaimed=true',
    requestBody,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const claimProductsIntoEvent = productsAndEventIds => {
  return AxiosUtil.put(
    EventConstants.POTENTIAL_ITEMS,
    productsAndEventIds,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getItemsAssociatedWithPlan = ({
  eventId,
  page,
  perPage,
  requestBody,
}) => {
  return AxiosUtil.post(
    EventConstants.POTENTIAL_ITEMS +
      'aggregations_search_with_bps?page=' +
      getPageUrl({ page, perPage, eventId }) +
      '&plan_claimed=true',
    requestBody,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getItemsAssociatedWithEvent = ({
  planId,
  page,
  perPage,
  requestBody,
}) => {
  return AxiosUtil.post(
    EventConstants.POTENTIAL_ITEMS +
      'aggregations_search_with_bps?page=' +
      getPageUrl({ page, perPage, planId }) +
      '&event_claimed=true',
    requestBody,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}
